import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


document.addEventListener("DOMContentLoaded", function() {

  (function introHeader() {
    blogIntroheader();
  })();
});

const blogIntroheader = () => {

  const container = document.querySelector(".hkbis__introheader.fixed-header-block");

  if (container) {

    const textContainer = container.querySelector(".hkbis__introheader .hkbis__introheader__text-container");
    const textToShow = container.querySelector(".hkbis__introheader .hkbis__introheader__text-container h2");
    const textToHide = container.querySelectorAll(".hkbis__introheader .hkbis__introheader__text-container > p");
    const image = container.querySelector(".hkbis__introheader .hkbis__introheader__image-container");
    const back = container.querySelector(".hkbis__introheader .hkbis__introheader__back");

    const textIsRightDesktop = container.classList.contains('hkbis__introheader--text-align-left-desktop');

    let marginTopMobile = '-15px';
    let marginTopDesktop = '-33px';
    if (!container.classList.contains('blog__single-introheader')) {
      marginTopMobile = '-15px';
      marginTopDesktop = '-33px';
      if (textToHide.length > 0) {
        marginTopMobile = '-18px';
        marginTopDesktop = '-36px';
      }
    }

    gsap.set(container, {zIndex: 20});
    gsap.timeline({
      scrollTrigger: {
        trigger: 'main',
        pin: container,
        anticipatePin: true,
        pinSpacing: false,
        start: "top top",
        end: 99999999,
      },
    });

    ScrollTrigger.matchMedia({
      "(min-width: 0px) and (max-width: 991px)": function () {

        let timeline = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            start: "top top",
            end: "bottom top+=200px",
            scrub: 1,
          },
        });

        timeline.to(back, {
          left: '10px',
          ease: "power0",
          duration: 3,
        }, 0);
        timeline.to(container, {
          height: 50,
          ease: "power0",
          duration: 3,
        }, 0);
        timeline.to(textToShow, {
          paddingLeft: '50px',
          marginTop: marginTopMobile,
          marginLeft: 0,
          marginRight: 'auto',
          fontSize: '14px',
          ease: "power0",
          duration: 3,
        }, 0);
        timeline.to(textToHide, {
          height: 0,
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: 0,
          marginBottom: 0,
          opacity: 0,
          x: "-100%",
          ease: "power0",
          duration: 1.5,
        }, 0);
        timeline.to(image, {
          height: 0,
          ease: "power0",
          duration: 3,
        }, 0);

      },
      "(min-width: 992px)": function () {

        let timeline = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            start: "top top",
            end: "bottom top+=200px",
            scrub: 1,
          },
        });

        timeline.to(back, {
          left: '20px',
          ease: "power0",
          duration: 3,
        }, 0);
        timeline.to(container, {
          height: 50,
          ease: "power0",
          duration: 3,
        }, 0);
        timeline.to(textContainer, {
          position: textIsRightDesktop ? 'absolute' : 'relative',
          right: textIsRightDesktop ? 0 : 'unset',
          width: '100%',
          height: 50,
          ease: "power0",
          duration: 3,
        }, 0);
        timeline.to(textToShow, {
          paddingLeft: '50px',
          marginTop: marginTopDesktop,
          marginLeft: 0,
          marginRight: 'auto',
          fontSize: '18px',
          ease: "power0",
          duration: 3,
        }, 0);
        timeline.to(textToHide, {
          height: 0,
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: 0,
          marginBottom: 0,
          opacity: 0,
          x: textIsRightDesktop ? "100%" :  "-100%",
          ease: "power0",
          duration: 1.5,
        }, 0);
        timeline.to(image, {
          position: 'absolute',
          height: 50,
          right: textIsRightDesktop ? 'unset' : 0,
          left: textIsRightDesktop ? 0 : 'unset',
          opacity: 0,
          x: textIsRightDesktop ? 0 : "100%",
          ease: "power0",
          duration: 3,
        }, 0);

      },
    });
  }
}
